import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './BillingView.m.sass';
import BillingMethods from '../../../../billing/components/BillingMethods';
import PayoutMethods from '../../../../billing/components/PayoutMethods';
import List from '../List';
import AddBillingMethodButton from '../../../../billing/components/AddBillingMethodButton';
import AddPayoutMethodButton from '../../../../billing/components/AddPayoutMethodButton';
import RequirePerms from '../../../containers/RequirePerms';
var BillingView = function BillingView(_ref) {
  var state = _ref.state,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'BILLING' : _ref$view;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, view === 'BILLING' ? /*#__PURE__*/React.createElement(BillingMethodsView, {
    state: state
  }) : /*#__PURE__*/React.createElement(PayoutMethodsView, {
    state: state
  }));
};
var BillingMethodsView = observer(function BillingMethodsView(_ref2) {
  var state = _ref2.state;
  var billingStore = state.billingStore,
    sessionStore = state.sessionStore,
    team = state.team,
    billingViewState = state.billingViewState;
  return /*#__PURE__*/React.createElement(List, {
    addButton: state.allowEdit && /*#__PURE__*/React.createElement(RequirePerms, {
      rootStore: state,
      anyOf: ['MANAGE_TEAM_BILLING'],
      subject: state.sessionStore.teamMembers.find(function (x) {
        return x.teamId === state.team.id;
      })
    }, /*#__PURE__*/React.createElement(AddBillingMethodButton, {
      disabled: state.billingStore.busy,
      onClick: state.team.id && sessionStore.workspace.features.billing.teamsCredit.enabled ? function () {
        return state.billingViewState.showCreateBillingModal();
      } : function (e) {
        return e.stopPropagation() || state.billingViewState.addBillingMethod();
      }
    }))
  }, /*#__PURE__*/React.createElement(BillingMethods, {
    onMethodClick: function onMethodClick(method) {
      return state.billingViewState.setDefaultTeamBillingMethod(method);
    },
    allowEdit: state.allowEdit,
    team: team,
    billingStore: billingStore,
    sessionStore: sessionStore,
    state: billingViewState
  }));
});
var PayoutMethodsView = observer(function PayoutMethodsView(_ref3) {
  var state = _ref3.state;
  return /*#__PURE__*/React.createElement(List, {
    addButton: state.allowEdit && /*#__PURE__*/React.createElement(RequirePerms, {
      rootStore: state,
      anyOf: ['MANAGE_TEAM_BILLING'],
      subject: state.sessionStore.teamMembers.find(function (x) {
        return x.teamId === state.team.id;
      })
    }, /*#__PURE__*/React.createElement(AddPayoutMethodButton, {
      disabled: state.billingStore.busy,
      onClick: function onClick() {
        return state.billingViewState.addPayoutMethod();
      }
    }))
  }, /*#__PURE__*/React.createElement(PayoutMethods, {
    onMethodClick: function onMethodClick(method) {
      return state.billingViewState.setDefaultTeamPayoutMethod(method);
    },
    billingStore: state.billingStore,
    allowEdit: state.allowEdit,
    team: state.team
  }));
});
export default observer(BillingView);
//# sourceMappingURL=index.js.map
